<ng-container *ngIf="form !== null">
  <div class="cf-dlg">

    <!-- HEADER -->
    <div class="cf-dlg-header">
      <div class="cf-dlg-icon"><mat-icon>work</mat-icon></div>
      <div>
        <h2 class="cf-dlg-title">
          {{ asuntosPropios.id > 0 ? 'Editar asuntos propios' : 'Nueva solicitud de asuntos propios' }}
        </h2>
        <p class="cf-dlg-subtitle" *ngIf="asuntosPropios.id > 0">
          Estado: <strong>{{ asuntosPropios.nombreEstado }}</strong>
        </p>
        <p class="cf-dlg-subtitle" *ngIf="asuntosPropios.id == 0">Indica el período y el motivo</p>
      </div>
    </div>

    <!-- BODY -->
    <div class="cf-dlg-body">
      <form [formGroup]="form">

        <div class="cf-dlg-row">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Empleado</mat-label>
            <mat-select formControlName="employees_Id">
              <mat-option *ngFor="let e of empleados; trackBy: trackByIndex" [value]="e.uid">{{ e.name }}</mat-option>
            </mat-select>
            <mat-hint>Empleado que solicita los asuntos propios</mat-hint>
            <mat-error *ngIf="form.controls['employees_Id'].hasError('required')">
              El empleado es <strong>obligatorio</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Inicio</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="inicio">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="form.controls['inicio'].hasError('required')">
              La fecha de inicio es <strong>obligatoria</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Fin</mat-label>
            <input matInput [matDatepicker]="picker2" formControlName="fin">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
            <mat-error *ngIf="form.controls['fin'].hasError('required')">
              La fecha de fin es <strong>obligatoria</strong>
            </mat-error>
          </mat-form-field>
        </div>

        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Motivo</mat-label>
          <textarea matInput rows="4" formControlName="motivo"></textarea>
          <mat-hint>Motivo de la solicitud</mat-hint>
          <mat-error *ngIf="form.controls['motivo'].hasError('required')">
            El motivo es <strong>obligatorio</strong>
          </mat-error>
        </mat-form-field>

      </form>
    </div>

    <!-- FOOTER -->
    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="cancel()">Cancelar</button>
      <ng-container *ngIf="asuntosPropios.estado == 1 && asuntosPropios.id > 0">
        <button mat-stroked-button class="cf-dlg-btn-warn" (click)="rechazar()">
          <mat-icon>close</mat-icon> Rechazar
        </button>
        <button mat-stroked-button class="cf-dlg-btn-success" (click)="validar()">
          <mat-icon>done</mat-icon> Validar
        </button>
      </ng-container>
      <button mat-flat-button class="cf-dlg-btn-primary" *ngIf="asuntosPropios.estado > 1" (click)="onSubmit()">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>

  </div>
</ng-container>
